import cv from '../assets/Adan-Fernandez-Software-Engineer-Resume.pdf';

export const socialLinks = [
  {
    id: 'github',
    label: 'GitHub',
    url: 'https://github.com/Adamyoelfc',
    icon: 'github',
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/in/adam-fernandez-330a011a8',
    icon: 'linkedin',
  },
  {
    id: 'email',
    label: 'Email',
    url: 'mailto:adamyoelfc@gmail.com',
    icon: 'email',
  },
  {
    id: 'telegram',
    label: 'Telegram',
    url: 'https://t.me/adamyoelfc',
    icon: 'telegram',
  },
];

export const cvUrl = cv;

export const contactInfo = {
  email: 'adamyoelfc@gmail.com',
  telegram: 't.me/adamyoelfc',
};
